module.exports = __webpack_public_path__ + "static/img/click2.8d34fa1e.png";